<app-floorplan-notes-menu></app-floorplan-notes-menu>
<hr />
<app-floorplan-free-text-menu></app-floorplan-free-text-menu>
